import moment from "moment";

export default function (date1, date2 = {}) {
  let moment1 = moment(date1);
  let moment2 = moment(date2);

  return moment1.from(moment2);
}
